import React, { FC } from 'react';
import { Grid, Space } from 'antd';
import { faBriefcase, faLaptopHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './dashboard.module.less';
import { ContentBlock, TextBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import { Logo } from '../../uicomp/atmos/logo/Logo';
import { useCachedData } from '../../connection/CacheContext';

export type JobRecommendedProps = {
  jobTitle: string;
  recruiterName: string;
  location: string[];
  jobPostId?: string;
  workplaceType?: string;
  jobCategory: string[];
  period: string;
  recruiterImage?: any;
};
type Props = {
  data: JobRecommendedProps;
  onView?: () => void;
};

export const JobRecommendCard: FC<Props> = (props) => {
  const { jobTitle, recruiterName, location, jobCategory, workplaceType, recruiterImage } =
    props.data;
  const bp = Grid.useBreakpoint();
  const { enumValue } = useCachedData();
  const cache = useCachedData();
  return (
    <div className={styles.shortlistCardContainer} onClick={props.onView}>
      <div style={{ width: '99%' }}>
        <ContentBlock
          gap={'lg'}
          vertical={!bp.sm}
          className={styles.jobCardTitleContainer}
          left={<Logo src={recruiterImage} />}>
          <Space direction={'vertical'} className={'fullwidth'} size={'small'}>
            <TextBlock heading>
              <a className={styles.alertTitleLink}>{jobTitle}</a>
            </TextBlock>
            <TextBlock level={1}>{recruiterName}</TextBlock>
            <TextBlock secondary>
              {Array.isArray(location)
                ? location?.map((v) => enumValue['Location']?.[v])?.join(' / ')
                : location
                ? enumValue?.['Location']?.[location]
                : ''}
            </TextBlock>
          </Space>
          <div className={styles.gap8}>
            <Space>
              <ContentBlock
                className={styles.contentCenterAlert}
                secondary
                left={<FontAwesomeIcon icon={faBriefcase} />}>
                {jobCategory?.map((v) => enumValue?.['Job Category']?.[v]).join(' / ')}
              </ContentBlock>
              {workplaceType && (
                <ContentBlock secondary left={<FontAwesomeIcon icon={faLaptopHouse} />}>
                  {cache?.enumValue['Workplace Type']?.[workplaceType]}
                </ContentBlock>
              )}
            </Space>
          </div>
        </ContentBlock>
        <Space direction={'vertical'} align={'end'} style={{ width: '100%' }}>
          <p>
            Ref. No{' '}
            {isNaN(Number(props.data.jobPostId))
              ? props?.data?.jobPostId?.substr(props?.data?.jobPostId?.length - 4).padStart(8, '0')
              : String(props.data.jobPostId).padStart(8, '0')}
          </p>
        </Space>
      </div>
    </div>
  );
};
